import { IconInfo } from './Icon';

function InfoHint({ children, style }) {
  return (
    <div
      className="d-flex align-items-start gap-1"
      style={{ fontSize: 12, color: '#888', marginTop: 4, ...style }}
    >
      <IconInfo size={13} style={{ flexShrink: 0, marginTop: 1, color: '#aaa' }} />
      <span>{children}</span>
    </div>
  );
}

export default InfoHint;
